import React, { Fragment } from "react";
import { inputClasses } from "../../styles/inputs";

const RenderInput = React.memo(
  ({ type, style, placeHolder, classes, attributes, onChange, onIconClick, icon }) => {
    const inputClass = inputClasses();
    const classList = classes.map((c) => inputClass[c] || "").join(" ");

    return (
      <div style={{ position: "relative", width: "100%" }}>
        {/* INPUT */}
        <input
          className={classList}
          type={type}
          style={{
            ...style,
          }}
          placeholder={placeHolder}
          {...attributes}
          onChange={onChange}
        />

        {/* ICONO CLICKABLE (DENTRO DEL INPUT) */}
        {icon && (
          <div
            onClick={onIconClick}
            style={{
              position: "absolute",
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
          >
            {icon}
          </div>
        )}
      </div>
    );
  }
);

export const Input = ({ type, style, placeHolder, classes = [], attributes, onChange, onIconClick, icon }) => (
    <Fragment>
        <RenderInput {...{ type, style, placeHolder, classes: [...classes, "input"], attributes, onChange, onIconClick, icon }}/>
    </Fragment>
);